<template src="./index.html"></template>
<script>
import {getdata} from "./data.js";
import { iinv_fetchResultShow } from "../../../../../api/iinv.js";
import config from "../../../../../../configHttp.js";
import {MainFunction} from "@/components/util/Function/MainFunction";
export default {
  name: "showresult",
  components: {},
  data: function () {
    return {
      searchdata: getdata().searchdata,
      searchlist: getdata().searchlist,
      outlist: [],
      headData: getdata().headData,
      pagination: getdata().pagination,
      tableData: [],
      shaidiag: false,
      searchdiag: false,
      // 日期控件初始化时间
      dateValue:  MainFunction.$getdefultMonth(),
      // 导出传参类型
      outputData: getdata().outputData,
      // 全部导出
      exportType: "1",
      tablekey: 0,
    };
  },
  // 页面加载
  mounted() {},
  created() {
    this.fetchResultShow();
  },

  computed: {
    timeDefault() {
      let date = new Date();
      let newDate = date.getFullYear() + "年" + (date.getMonth() + 1) + "期";
    },
  },
  methods: {
    sizechange(e) {
      this.pagination.pageSize = e;
      this.fetchResultShow();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.fetchResultShow();
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.fetchResultShow();
    },
    forRefresh() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.fetchResultShow();
    },

    forUpdateSearch() {
      this.searchdiag = true;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeshaidiag() {
      this.shaidiag = false;
    },

    // 查询进行发票合计结果(分页)
    fetchResultShow() {
      let params = JSON.parse(JSON.stringify(this.searchdata));
      params.page = this.pagination.pageNum;
      params.size = this.pagination.pageSize;
      params.sort = "";
      params.order = "";
      params.suosq = this.dateValue;
      iinv_fetchResultShow(params).then((res) => {
        this.pagination.total = res.data.data.total;
        this.tableData = res.data.data.records;
      });
    },

    // 导出进项发票合计结果
    outPutIInvResult() {
      let selectVal = this.$refs.tablebox.getSelectionval();
      if (selectVal.length == 0) {
        this.$message.info("请选中数据再进行导出操作");
        return;
      }
      let fapdms = new Array(selectVal.length);
      selectVal.forEach((v, k) => {
        fapdms[k] = v.fapdm;
      });
      let params = {
        downUrl: config.baseURL + "/iinv/list/export",
        typeObj: {
          toForm: false,
          fileName: "进项增值税结果展示" + this.$timestampToStr(new Date(), "yyyyMMdd"),
          fileType: "xlsx",
          failUrl:this.$winURl
        },
        params: {
          exportType: this.exportType,
          suosq: this.dateValue,
          fapdms,
        },
      };
      this.$downloadcommon(params);
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
